export default __webpack_public_path__ + "static/media/BITS PILANI.40568875.png";